var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventTargetInterruptSource } from './eventtargetinterruptsource';
/*
 * An interrupt source on the Window object.
 */
var /*
 * An interrupt source on the Window object.
 */
WindowInterruptSource = (function (_super) {
    __extends(WindowInterruptSource, _super);
    function WindowInterruptSource(events, options) {
        return _super.call(this, window, events, options) || this;
    }
    return WindowInterruptSource;
}(EventTargetInterruptSource));
/*
 * An interrupt source on the Window object.
 */
export { WindowInterruptSource };
//# sourceMappingURL=windowinterruptsource.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ng-idle/core/src/windowinterruptsource.js
// module id = ./node_modules/@ng-idle/core/src/windowinterruptsource.js
// module chunks = vendor